import React, { useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Link } from "react-router-dom";

import { togglePopover } from "../../redux/Slices/popoverSlice";
import { fetchBoardsByWorkspaceAndMember } from "../../redux/Slices/boardsSlice";

import './scss/popoverBoardList.scss';
import ImagePlaceholder from "../Global/ImagePlaceholder";
import Spinner from "../Global/Spinner";

const PopoverBoardList = ({ member, workspaceId }) => {
    const dispatch = useDispatch();

    // Access boards and status from Redux state. Select each value separately so
    // each useSelector returns a stable primitive/reference — returning a new
    // `{ memberBoards, status }` object from one selector creates a fresh
    // reference every call and triggers React-Redux's unstable-selector warning.
    const memberBoards = useSelector((state) => state.boards.memberBoards);
    const status = useSelector((state) => state.boards.status);



    useEffect(() => {
        // Fetch boards when the component mounts
        dispatch(fetchBoardsByWorkspaceAndMember({ workspaceId, memberId: member._id }));
    }, [dispatch, workspaceId, member._id]);

    return (

        <div className="board-list">
            {status === "loading" ? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                    <Spinner size={30} color="#3498db" speed={1.5} />
                </div>
            ) : (

                <>
                    <h2>Workspace boards</h2>
                    <p>
                        <strong>@{member.username}</strong> is a member of the following Workspace boards:
                    </p>
                    <ul>
                        {memberBoards?.length > 0 ? (
                            memberBoards.map((board, index) => (
                                <li key={index} className="board-item">
                                    <Link
                                        to={board.permalink}
                                        onClick={() => {
                                            dispatch(togglePopover({
                                                contentId: null,
                                                position: { top: 0, left: 0 },
                                                targetId: null,
                                            }));
                                        }}
                                    >
                                        <div className="board-thumbnail">
                                            <ImagePlaceholder size={30} text={board.title} onlineIndicator={false} />
                                        </div>
                                        <div className="board-title">{board.title}</div>
                                    </Link>
                                </li>
                            ))
                        ) : (
                            // Show message if no boards are found
                            <p>No boards available for this member.</p>
                        )}
                    </ul>
                </>
            )}
        </div>
    );
};

export default PopoverBoardList;



